// ************************************************************************************************
// pathname: /v2/publication/activate/{jobSlug}
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/** Props */
type PostData = ApiSchema<'GeneralActivationData'>;
type Response = ApiSchema<'JobPostingResponse2'>;

interface UseSwrActivateJobProps {
  locale: Locale,
  payload?: PostData,
  jobSlug?: string,
  draftMode?: boolean,
  successCallback?: (data: Response) => void,
  errorCallback?: (error: ApiSchema<'ErrorResponse'>) => void,
}

/**
 * @description SWR: fetch activate job data
 * - `locale` - the current locale
 * - `jobSlug` - the job slug
 * - `payload` - the post data object
 * - `draftMode` - the draft mode
 * - `successCallback` - success callback function
 * - `errorCallback` - error callback function
 */
export const useSwrActivateJob = (props: UseSwrActivateJobProps) => {
  const {
    locale,
    jobSlug,
    payload,
    draftMode,
    successCallback,
    errorCallback,
  } = props;

  return useSwrMutationApi<Response, PostData>({
    url: `/v2/publication/activate${jobSlug ? `/${jobSlug}` : ''}`,
    urlParams: draftMode ? '?draftMode=1' : '',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      ...(payload ? { payload } : {}),
    },
    apiOptions: {
      onSuccess: (response) => {
        if (successCallback) successCallback(response);
      },
      onError: (error) => {
        if (errorCallback) errorCallback(error);
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });
};
